import { useTranslation } from 'react-i18next'

const TeacherEnvironmentEnd = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 1920 1080" 
      role="image"
      aria-labelledby="teacher-environment-end-title"
      fill="none"
      {...props}
    >
      <title id="teacher-environment-end-title">{t('antagonists:teacherEnvironment:components:end')}</title>
      <defs>
        <clipPath id="teacher-environment-a">
          <path
            d="M1417.04 977.46c-8.05 5.45-9.08 18.49-9.08 18.49s13.75 2.44 26.68 3.39c25.34 1.88 45.31-2.02 58.24-3.28 18.93-1.84 40.2-7.82 40.2-7.82s-2.42-7.84-3.61-20.54-6.33-23.24-6.33-23.24l-2.21.18s5.41 14.46-10.51 14.96c-21.01.66-29.21-9.14-29.21-9.14s4.12-5 3.4-8.35c-.48-2.21-4.21-3.53-4.21-3.53s-13.13 10.98-20.04 18.08c-6.92 7.1-22.37 15.31-25.65 16.2-6.47 1.76-14.9 2.73-17.65 4.59Z"
            style={{
              fill: '#2a5151',
            }}
          />
        </clipPath>
        <clipPath id="teacher-environment-b">
          <path
            d="M1580.7 932.82c-6.21.34-10.62 8.92-14.44 10.83-3.82 1.91.21 8.28-.85 19.53-1.06 11.25-2.12 15.5-2.12 20.38s2.12 8.07 2.12 8.07 20.6-.21 31-.85c10.4-.64 15.08-2.12 15.08-2.12s2.12-4.03-.21-10.62c-2.34-6.58-5.73-9.55-7.22-19.32s-3.61-13.59-3.61-13.59-2.76-1.7-6.16-5.52c-3.4-3.82-5.48-7.24-13.59-6.79Z"
            style={{
              fill: '#2a5151',
            }}
          />
        </clipPath>
      </defs>
      <path
        d="M1482.95 921.9s1.83 10.25-1.4 17.98-14.33 20.6-13.7 20.52 47.53 5.93 47.53 5.93l8.84-16.85s-4.33-9.7-5.37-20.48c-1.05-10.79-1.48-18.66-1.48-18.66l-34.42 11.56Zm90.1-4.16-5.09 31.22 29.94 7.21 2.97-4.45-3.4-26.12-24.42-7.86z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="M1481.7 529.9c-1.54 2.51-5.46 39.2-17.87 56.48-12.41 17.29-11.66 37.77-12.92 70.85-1.25 33.08 4.34 97.31 2.9 115.37-1.44 18.06 11.12 68.16 16.15 92.87 5.03 24.7 8.76 72.22 8.76 72.22s13.7 4.2 26.23 3.04 21.28-6.77 21.28-6.77-.46-63.97-5.18-102.51c-4.72-38.55-14.89-47.05-10.57-65.73 4.32-18.68 26.75-94.18 26.75-94.18l15.68-126.6-71.22-15.03Z"
        style={{
          fill: '#516386',
        }}
      />
      <path
        d="M1516.6 555.43s25.16 153.13 32.27 182.67c7.11 29.53 6.8 37.81 6.8 44.77 0 8.93 4.68 15.94 6.32 35.63 1.64 19.69 3.83 115.94 3.83 115.94s9.3.55 19.69 1.64 18.59-1.64 18.59-1.64 16.95-79.85 14.22-118.13c-2.73-38.28-12.03-68.91-8.2-93.52s9.95-77.67 10.5-103.92c.55-26.25-13.24-49.21-21.44-77.1-8.2-27.89-19.14-47.03-19.14-47.03l-63.44 60.71Z"
        style={{
          fill: '#516386',
        }}
      />
      <path
        d="M1417.04 977.46c-8.05 5.45-9.08 18.49-9.08 18.49s13.75 2.44 26.68 3.39c25.34 1.88 45.31-2.02 58.24-3.28 18.93-1.84 40.2-7.82 40.2-7.82s-2.42-7.84-3.61-20.54-6.33-23.24-6.33-23.24l-2.21.18s5.41 14.46-10.51 14.96c-21.01.66-29.21-9.14-29.21-9.14s4.12-5 3.4-8.35c-.48-2.21-4.21-3.53-4.21-3.53s-13.13 10.98-20.04 18.08c-6.92 7.1-22.37 15.31-25.65 16.2-6.47 1.76-14.9 2.73-17.65 4.59Z"
        style={{
          fill: '#2a5151',
        }}
      />
      <g
        style={{
          clipPath: 'url(#teacher-environment-a)',
        }}
      >
        <path
          d="M1407.1 983.63s4.63 3.77 25.32 5.63c20.7 1.87 39.05-1.19 55.55-2.97 16.5-1.78 45.64-11.11 45.64-11.11l1.15 21.63-135.26 7.55 7.6-20.73Z"
          style={{
            fill: '#e6eef8',
          }}
        />
      </g>
      <path
        d="M1580.7 932.82c-6.21.34-10.62 8.92-14.44 10.83-3.82 1.91.21 8.28-.85 19.53-1.06 11.25-2.12 15.5-2.12 20.38s2.12 8.07 2.12 8.07 20.6-.21 31-.85c10.4-.64 15.08-2.12 15.08-2.12s2.12-4.03-.21-10.62c-2.34-6.58-5.73-9.55-7.22-19.32s-3.61-13.59-3.61-13.59-2.76-1.7-6.16-5.52c-3.4-3.82-5.48-7.24-13.59-6.79Z"
        style={{
          fill: '#2a5151',
        }}
      />
      <g
        style={{
          clipPath: 'url(#teacher-environment-b)',
        }}
      >
        <path
          d="M1558.61 982.72s11.47-5.1 25.9-4.03c15.05 1.11 16.61 2.78 24.84 2.55 7.43-.21 18.26-2.55 18.26-2.55l.64 23.99-63.27-1.06-6.37-18.9Z"
          style={{
            fill: '#e6eef8',
          }}
        />
      </g>
      <path
        d="M1530.61 293.19c-25.86 6.98-53.13 7.67-54.63 9.45s.88 13.92.88 13.92L1445.72 333s-.67 9.99-.67 28.65v62.63l173.23 3s31.32-66.63 25.65-76.96c-5.66-10.33-35.51-24.1-45.17-32.43-9.66-8.33-8.24-25.26-9.81-27.85s-37.37-2.52-58.35 3.14Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1457.22 570.7s13.5 9.86 48.97 16.67c35.47 6.81 87.53-7.29 87.53-7.29l-10.94-268.72-37.78-14.53-46.51 14.11s-35.11 230.38-36.19 230.74-5.08 29.03-5.08 29.03Z"
        style={{
          fill: '#dac941',
        }}
      />
      <path
        d="M1513.76 297.55s-14.4 40.78-18.73 80.09-3.33 127.59-4.33 152.58c-1 24.99-.78 70.17-.78 70.17s-13.5 4.97-26.59.32c-13.1-4.65-20.6-5.53-20.6-5.53s1.71-7.99.33-23.65c-1.62-18.43-8-37.98-8-37.98s15.99-63.3 17.99-88.62c2-25.32-.67-53.97-6.33-71.62-5.66-17.66-3.46-39.57-3.46-39.57l70.5-36.19Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1446.19 332.43c-10.39 4.87-11.64 10.16-17.97 30.15-6.33 19.99-23.47 72.7-22.47 87.36 1 14.66 12.99 55.3 18.66 71.62 5.66 16.32 14.66 12.99 14.66 12.99l17.32-50.3s-8.99-20.65-8.99-25.32 12.99-54.97 14.66-61.3.46-72.87-15.86-65.2Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1504.32 264.13s4.69 29.24 4.36 39.24c-.33 9.99-6.36 30.67 11.63 36.33 17.99 5.66 35.09 2.27 41.42-8.72 6.33-10.99 1.27-19.63-.73-25.29s6.54-43.74 6.54-43.74l-63.21 2.18Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1535.09 194.12c-7.48-1.29-4.61-6.25-11.64-5.71s-11.42 14.86-16.92 15.32c-5.5.46-6.2-6.83-6.2-6.83s-6.58 6.04-5.47 10.62c1.1 4.57 1.69 5.79.49 7.24-1.2 1.45-7.62 2.13-7.89 7.04-.27 4.91 3 10.41-1.26 12.02-4.26 1.61-9.84 6.15-6.32 11.5 3.52 5.35 7.11 12.22 4.29 14.16-2.82 1.94-5.5.46-5.5.46s.85 7.54 4.65 8.85c3.8 1.31 11.54 3.06 12.02 9.43.47 6.37-4.23 12.68 4.75 20.41 8.58 7.38 10.82 20.33 25.2 21.04 22.79 1.11 21.04-6.46 30.86-10.67 9.83-4.21 15.67-15.69 15.34-19.87-.33-4.18 3.6-7.37 5.18-4.84 1.58 2.52 1.35 4.62 1.35 4.62s5.32-.46 7.14-5.69c1.25-3.58-4.86-8.89-2.1-11.5 2.76-2.6 13.86-9.54 11.53-22.82-2.34-13.28-12.07-15.09-10.25-24.82 1.81-9.73.61-19.51-11.71-23.22-12.32-3.71-15.85 1.31-19.35-3.17s-3.44-9.43-10.28-9.71-7.9 6.17-7.9 6.17Z"
        style={{
          fill: '#5b3346',
        }}
      />
      <path
        d="M1553.24 215.97c-5.68-.19-4.51 1.77-10.44 4.07-5.93 2.3-13.09-1.29-18.52.7s-4.29 5.49-8.42 8.42c-4.13 2.93-16.42 9.39-17.79 15.33-1.37 5.95 4.97 9.52 4.23 17.45-1.23 13.17 1.58 18.69 5.38 22.35 5.18 4.99 7.89 14.84 12.7 15.52s-2.33-8.03 1.03-8.55c3.36-.52 4.45 2.19 8.08 2.38 3.63.19 7.62-2.13 7.67.47.05 2.6-2.46 6.77.57 7.68 3.03.91 6.63-7.96 10.79-9.16 4.16-1.2 11.23-5.62 13.39-10.3 2.16-4.68 1.95-10.35 4.89-14.64 2.93-4.29 4.02-11.81 3.81-17.48-.21-5.66-4.97-3.74-3.53-11.83 1.43-8.09-1.83-22.02-13.83-22.41Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        style={{
          fill: '#272a3e',
        }}
        d="m1546.45 251.09 12.35 3.68-1.15 3.02-11.85-4.64.65-2.06z"
      />
      <path
        d="M1548.72 256.02c-.2 1.3-.01 3.44 2.77 3.9 3.13.52 4.04-1.79 4.14-2.79.19-1.9-1.5-3.08-3.02-3.14-2.08-.08-3.67.63-3.89 2.03Zm-25.11-7.32-12.19-.36-.31 3.07 12.3-.28.2-2.43z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="M1522.42 252.89c-.11 1.31-.54 3.13-3.36 2.93-3.16-.23-3.5-2.69-3.36-3.69.27-1.9 2.19-2.64 3.68-2.34 2.04.41 3.16 1.69 3.04 3.1Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="M1532.67 277.38c-6.49-.02-11.37-5.56-18.7-2.16-3.92 1.82-4.58 6.1-2.18 7.68s5.67-4.12 11.6-2.92c5.93 1.2 14.73 1.16 18.71 2.59 3.98 1.43 6.31 4.04 8.66 3.55 2.35-.49 1.99-6.36-2.9-8.35s-11.6-.38-15.19-.39Z"
        style={{
          fill: '#5b3346',
        }}
      />
      <path
        d="M1520.7 283.85c.15 1.76-.61 4.8 4.43 6.94 5.03 2.14 7.59 2.1 10.01 1.33 3.67-1.17 6.55-3.36 6-5.98-.25-1.21-4.67-4.03-6.29-3.68s-2.86.56-3.93.24-1.98-1.76-4.73-1.83c-2.75-.06-5.67.91-5.5 2.98Z"
        style={{
          fill: '#eb8d05',
        }}
      />
      <path
        d="M1544.4 241.15s11.76.13 15.27 2.59 6.94 6.08 6.94 6.08l-2.47 1.36s-2.92-3.03-7.17-3.99-13.14-1.36-12.88-1.48.32-4.56.32-4.56Zm-15.08-.09s-11.19-3.63-15.29-2.42-7.08 4.71-7.08 4.71l1.3 1.99s2.9-3.01 7.24-2.57 12.89 2.9 12.68 2.71 1.16-4.42 1.16-4.42Z"
        style={{
          fill: '#613f2f',
        }}
      />
      <path
        d="m1568.46 255.75.17-3.36-5.74-.78s-3.08-3.63-7.96-4.14c-2.77-.29-8.14-.69-10.06-.4-4.62.7-5.83 2.96-5.83 2.96s-2.13-1.39-4.37-1.53-4.41.56-4.41.56-.68-2.47-5.04-4.18c-1.81-.71-7.13-1.5-9.9-1.83-4.87-.58-8.68 2.28-8.68 2.28l-5.65-.74-.56 4.17 4.21 1.07s.12 4.81.4 7.01c.51 4.01 2.56 9.31 12.18 10.09 9.48.77 12.97-7.42 13.82-9.64.52-1.35.21-3.67.58-5.02.13-.48 1.36-.99 2.81-.82s2.55.91 2.57 1.41c.06 1.4-.75 3.59-.54 5.03.34 2.36 1.93 11.11 11.35 12.46 9.56 1.37 13.09-3.93 14.11-7.15.67-2.11 1.94-6.75 1.94-6.75l4.61-.69Zm-49.74 9.01c-6.07-.2-8.92-1.99-10.74-6.1-1.81-4.11-1.01-9.35 1.15-11.54 2.7-2.74 10.87-1.16 14.98.17 2.43.78 4.73 2.75 4.67 6.87-.06 4.12-3.75 10.81-10.07 10.6Zm39.94-.44c-2.68 3.61-5.86 4.72-11.82 3.58-6.22-1.19-8.33-8.53-7.48-12.57.85-4.03 3.54-5.45 6.07-5.67 4.31-.38 12.62-.12 14.65 3.15 1.62 2.61 1.25 7.9-1.42 11.51Z"
        style={{
          fill: '#ececdb',
        }}
      />
      <path
        d="M1553.95 305.31s7.18 8.65 9.45 23.94c2.26 15.29 7.01 33.09 2.68 50.41-8.66 34.65-15.75 119.92-17.41 147.57-1.67 27.65-4.67 79.68-4.67 79.68s15.33-5.06 30.99-4.06c15.66 1 46.45-5.91 46.45-5.91s-4.42-26.6-3.42-44.92-1.3-62.61-.64-86.59 20.26-103.95 22.92-114.61c2.67-10.66-28.16-18.31-43.33-33.8-4.26-4.35-22.82-27.42-22.82-27.42l-20.2 15.71Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1616.4 597.47s-8.89 14.91-10.29 19.15c-1.4 4.24-2.16 14.48-3 18.63s-2.11 11.99-2.11 11.99 5.95.78 8.19-3.14c2.24-3.93 3.53-17.47 4.93-17.25 1.39.22-2.01 14.68-3.58 18.9-1.57 4.21-6.93 6.39-8.94 8.92-2.02 2.53-2.29 5.35-2.29 5.35l13.9 1.35s10.3-4.05 14.82-5.47 7.98-4.07 10.2-6.75c1.5-1.81 4.85-15.65 4.85-15.65l.75-38.33s-6.24-.38-12.86-1.45c-6.62-1.07-14.55 3.77-14.55 3.77Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1643.44 349.64c12.71 15.06 23.97 118.04 25.83 134.46 1.02 9-5.16 36.2-10.62 65.46-5.46 29.26-13.27 57.33-13.27 57.33s-12.03-.99-20.7-4.83c-10.1-4.48-19.03-9.58-19.03-9.58s4.41-69.63 5.55-89.79c1.13-20.15-10.45-57.16-10.45-57.16l28-92.5 14.68-3.38Z"
        style={{
          fill: '#1c3628',
        }}
      />
    </svg>
  )
}

export default TeacherEnvironmentEnd
